export default __webpack_public_path__ + "static/media/20.3a3d609d.jpg";